import { RootState } from '@rb-serve-app/core';
import { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';

interface ContactUsProps {
  isContactUsOpened: boolean;
  setIsContactUsOpened: Dispatch<SetStateAction<boolean>>;
}

const ContactUs = ({
  isContactUsOpened,
  setIsContactUsOpened,
}: ContactUsProps) => {
  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );
  const { entries, assets } = contentfulData;
  const { rb_contact_us, rb_links } = entries;
  const isDisplaySecureMessage = rb_contact_us?.isDisplaySecureMessage || false;

  const navigate = useNavigate();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      aria-labelledby="modal-title"
      aria-modal="true"
      role="dialog"
    >
      <div
        id="contactUs"
        className="relative w-full sm:w-[95%] md:w-[70%] lg:w-[60%] xl:w-[40%] max-h-full overflow-y-auto bg-white md:rounded-2xl shadow-lg p-5 md:p-10"
        role="alert"
      >
        <img
          src={assets?.popup_close_icon}
          alt="closeIcon"
          className="w-6 h-6 absolute top-5 right-5 cursor-pointer"
          data-testid="close-icon"
          onClick={() => setIsContactUsOpened(false)}
        />

        <p
          className="text-2xl font-medium text-center text-[#1f1f1f] mb-6"
          aria-label={rb_contact_us.contactUs.title}
        >
          {rb_contact_us.contactUs.title}
        </p>

        {isDisplaySecureMessage && (
          <div className="border rounded-2xl p-5 mb-5 flex justify-between items-start gap-4 flex-col md:flex-row">
            <div>
              <p
                className="font-semibold text-[#1f1f1f] mb-2"
                aria-label={rb_contact_us.contactUs.secureMessage}
              >
                {rb_contact_us.contactUs.secureMessage}
              </p>
              <p
                className="text-[#1f1f1f] mb-4 md:mb-0"
                aria-label={rb_contact_us.contactUs.webSecureMsgDes}
              >
                {rb_contact_us.contactUs.webSecureMsgDes}
              </p>
            </div>
            <Button
              aria-label={rb_contact_us.contactUs.send}
              variant="solid"
              onClick={() => {
                navigate('/secure-messages');
                setIsContactUsOpened(false);
              }}
              className={
                'bg-red-600 text-white text-sm font-medium py-2 px-4 md:mt-8 sm:w-auto w-full'
              }
            >
              {rb_contact_us.contactUs.send}
            </Button>
          </div>
        )}

        <div className="border rounded-2xl p-5 mb-5">
          <p
            className="font-semibold text-[#1f1f1f] mb-2"
            aria-label={rb_contact_us.contactUs.secureMessageDis}
          >
            {rb_contact_us.contactUs.secureMessageDis}
          </p>
          <div className="text-[#1f1f1f] space-y-2">
            <div className="flex justify-between">
              <p aria-label={rb_contact_us.contactUs.callDis}>
                {rb_contact_us.contactUs.callDis}
              </p>
              <p aria-label={rb_contact_us.contactUs.callContact}>
                {rb_contact_us.contactUs.callContact}
              </p>
            </div>
            <div className="flex md:justify-between">
              <p
                className="w-[178px] md:w-auto"
                aria-label={rb_contact_us.contactUs.outsideNorthAmerica}
              >
                {rb_contact_us.contactUs.outsideNorthAmerica}
              </p>
              <p aria-label={rb_contact_us.contactUs.callOutside}>
                {rb_contact_us.contactUs.callOutside}
              </p>
            </div>
          </div>
        </div>

        <div className="border rounded-2xl p-5 flex justify-between items-center flex-col md:flex-row">
          <p
            className="font-semibold text-[#1f1f1f] md:mb-0 mb-4"
            aria-label={rb_contact_us.contactUs.webVisitText}
          >
            {rb_contact_us.contactUs.webVisitText}
          </p>
          <Button
            aria-label={rb_contact_us.contactUs.visit}
            variant="solid"
            onClick={() => {
              setIsContactUsOpened(false);
              window.open(rb_links.rbLinksCollection.contact_us, '_blank');
            }}
            className={
              'bg-red-600 text-white text-sm font-medium py-2 px-4 sm:w-auto w-full'
            }
          >
            {rb_contact_us.contactUs.visit}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
